<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content='赋值角色'></el-page-header>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-form-item label="角色名称">
				<el-input v-model="name" placeholder="请输入角色名称" readonly></el-input>
			</el-form-item>
			<el-form-item label="赋值角色">
				<el-select v-model="item.roleIds" clearable placeholder="请选择">
					<el-option v-for="item in options" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				name: this.$route.query.name,
				options: []
			}
		},
		created() {
			console.log(this.name);
			if (this.id) {
				this.loadItem()
			}
		},
		methods: {
			async loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''

				res = await this.axios.post('/admin/user/role/list', {})
				this.options = res.data

				this.isLoad = !this.isLoad
			},
			goBack() {
				this.$router.back(-1)
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad3
				this.item.userId = this.id
				let url = ''
				url = '/admin/user/user/addRole'
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})

			}
		}
	}
</script>
<style>
</style>
